/** Minimal markdown -> HTML conversion for legacy content loaded into the rich text editor. */
export const markdownToHtml = (md = '') => {
  const inline = (t) =>
    t
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|\s)\*(?!\s)(.+?)\*/g, '$1<em>$2</em>')
      .replace(/\[(.+?)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2">$1</a>');

  const blocks = [];
  let list = null;

  const closeList = () => {
    if (list) {
      blocks.push(`<${list.tag}>${list.items.map((i) => `<li>${i}</li>`).join('')}</${list.tag}>`);
      list = null;
    }
  };

  md.split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (!line) return closeList();

    const heading = line.match(/^(#{1,4})\s+(.*)$/);
    if (heading) {
      closeList();
      const level = Math.min(Math.max(heading[1].length, 2), 4);
      return blocks.push(`<h${level}>${inline(heading[2])}</h${level}>`);
    }

    const ordered = line.match(/^\d+[.)]\s+(.*)$/);
    const bullet = line.match(/^[-*•]\s+(.*)$/);
    if (ordered || bullet) {
      const tag = ordered ? 'ol' : 'ul';
      if (!list || list.tag !== tag) {
        closeList();
        list = { tag, items: [] };
      }
      return list.items.push(inline((ordered || bullet)[1]));
    }

    if (line.startsWith('>')) {
      closeList();
      return blocks.push(`<blockquote>${inline(line.replace(/^>\s?/, ''))}</blockquote>`);
    }

    closeList();
    blocks.push(`<p>${inline(line)}</p>`);
  });

  closeList();
  return blocks.join('');
};

export default markdownToHtml;
